import React, { useEffect, useState } from 'react';
import { getImageUrl } from '../../../../../services/imageStore';
import GeneralIcon from '../../../../../assets';

export default function VariantItem({ v, onEdit, onDelete }) {
  const [imgUrl, setImgUrl] = useState(v?.mainImage?.url || null);

  useEffect(() => {
    let active = true;
    async function resolve() {
      if (v?.mainImage?.key) {
        const url = await getImageUrl(v.mainImage.key);
        if (active) setImgUrl(url);
      } else {
        setImgUrl(v?.mainImage?.url || null);
      }
    }
    resolve();
    return () => { active = false; };
  }, [v?.mainImage]);
  return (
    <div className="border rounded p-3 flex gap-3 items-center">
      <div className="w-16 h-16 bg-gray-50 rounded overflow-hidden flex items-center justify-center">
        {imgUrl ? (
          <img src={imgUrl} className="w-full h-full object-cover" />
        ) : (
          <div className="text-gray-300">img</div>
        )}
      </div>

      <div className="flex-1">
        <div className="font-medium">{v.name}</div>
        <div className="text-sm text-gray-500">{v.description}</div>

        <div className="flex gap-2 mt-2">
          {Object.entries(v.properties).map(([name, value]) => (
            <div key={name} className="text-xs px-2 py-1 bg-gray-100 rounded">
              {value}
            </div>
          ))}
        </div>
      </div>

      <div className="flex flex-col gap-2">
        <button onClick={onEdit} className="p-2 rounded border text-purple-600">
          <GeneralIcon iconName="editar" className="h-5 w-5" />
        </button>
        <button onClick={onDelete} className="p-2 rounded border text-red-500">
          <GeneralIcon iconName="lixeira" className="h-5 w-5" />
        </button>
      </div>
    </div>
  );
}
